var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShape2Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 60,
    viewBox: "0 0 550 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M309.764 297.931a443.4 443.4 0 01-31.404-1.135c-19.688-1.394-39.148-6.564-55.588-11.441-58.288-17.307-117.528-45.908-158.43-76.479C25.304 179.63 3.802 149.781.454 120.191-2.583 93.37 9.639 67.16 36.792 42.309c8.284-7.587 16.71-12.653 25.761-15.483a57.837 57.837 0 0117.58-2.624c16.507 0 33.065 6.409 49.075 12.602 16.01 6.193 32.67 12.636 49.254 12.636 14.803 0 28.165-5.161 40.843-15.698 13.142-10.942 23.686-24.688 32.239-42.03 9.001-18.235 14.914-38.596 20.633-58.277 4.917-17.023 10.038-34.691 17.148-51.078 2.261-5.161 4.614-10.004 7.103-14.554l-.844-.379c.043-.18.043-.18 5.812-8.335l3.956-5.471c1.021-1.445 1.527-2.159 1.831-2.511C322.206-168.901 340.156-179 360.594-179c16.871 0 35.386 6.882 54.981 20.55 17.25 12.043 34.955 28.885 52.627 50.183 38.279 46.123 72.45 109.812 77.79 145.002a342.51 342.51 0 013.424 31.896c2.185 35.741-1.771 68.342-11.75 96.883-9.236 26.857-24.647 51.068-44.943 70.604C450.632 276.599 387.385 298 309.815 298l-.051-.069z",
    fill: "url(#shape-2_inline_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shape-2_inline_svg__paint0_linear",
    x1: 550,
    y1: -179,
    x2: 654.678,
    y2: 273.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

export default SvgShape2Inline;